import { getIncidentRelatedGraph } from "./ticket_service";

export function createEmptyIncidentContext() {
	return {
		problems: [],
		related_incidents: [],
		related_changes: [],
		direct_relation_ids: {
			problems: {},
		},
		allowed_transitions: [],
		counts: {
			problems: 0,
			related_incidents: 0,
			related_changes: 0,
		},
	};
}

export function normalizeIncidentRelatedGraph(payload) {
	return {
		problems: Array.isArray(payload?.problems) ? payload.problems : [],
		related_incidents: Array.isArray(payload?.related_incidents) ? payload.related_incidents : [],
		related_changes: Array.isArray(payload?.related_changes) ? payload.related_changes : [],
		direct_relation_ids: {
			problems: payload?.direct_relation_ids?.problems || {},
		},
		allowed_transitions: Array.isArray(payload?.allowed_transitions) ? payload.allowed_transitions : [],
		counts: {
			problems: Number(payload?.counts?.problems || 0),
			related_incidents: Number(payload?.counts?.related_incidents || 0),
			related_changes: Number(payload?.counts?.related_changes || 0),
		},
	};
}

export async function getIncidentContext(incidentId) {
	const payload = await getIncidentRelatedGraph(incidentId);
	return normalizeIncidentRelatedGraph(payload);
}
